import { DEVICE_PLATFORM } from 'src/utils/constants/AppConstants';
import { HTTP_HEADER_KEYS } from 'src/utils/constants/HttpMethodsConstants';
import { DisplayLanguage } from 'src/utils/constants/stringConstants';

import { FETCH_TVSHOW_RELAVANT_CONTENTS_QUERY } from '../../GraphQL/Queries/TvshowRelatedContentQuery';
import { TvShowRelatedContent } from '../../GraphQL/Queries/types';
import { graphQlRequest } from '../../GraphQL/RequestHandler';
import { GQL_QUERIES } from '../../../utils/analytics/newrelic/ErrorTracker';
// const id1 = '0-6-366';
const generateTvShowRelavantContentQueryParams = (
  contentId: string | undefined,
  country: string,
  translation: string,
  languages: string,
  platform: string,
  limit = 25
) => {
  const queryParams = {
    id: contentId,
    country,
    translation,
    platform,
    collectionFilter: {
      country,
      translation,
      languages,
      page: 1,
      limit,
      itemLimit: 20
    }
  };
  return queryParams;
};

export const fetchTvShowRelatedContents = async (
  assetId: string | undefined,
  country: string,
  translation = 'en',
  languages: string,
  platform = 'mobile-web'
): Promise<TvShowRelatedContent> => {
  try {
    const response: any = await graphQlRequest(
      FETCH_TVSHOW_RELAVANT_CONTENTS_QUERY,
      generateTvShowRelavantContentQueryParams(
        assetId,
        country,
        translation,
        languages,
        platform
      ),
      GQL_QUERIES.FETCH_TVSHOW_RELAVANT_CONTENTS_QUERY
    );
    return response.tvShowRelatedContent || {};
  } catch (error) {
    console.error('Error while fetching latest episodes: ', error);
    return {};
  }
};

export const fetchTvShowRelatedContentsForBot = async (
  assetId: string | undefined,
  country: string,
  translation: string = DisplayLanguage.ENGLISH,
  languages: string,
  platform = DEVICE_PLATFORM.MOBILE_WEB
): Promise<TvShowRelatedContent> => {
  try {
    const queryParams = generateTvShowRelavantContentQueryParams(
      assetId,
      country,
      translation,
      languages,
      platform,
      10
    );
    const response: any = await graphQlRequest(
      FETCH_TVSHOW_RELAVANT_CONTENTS_QUERY,
      queryParams,
      GQL_QUERIES.FETCH_TVSHOW_RELAVANT_CONTENTS_QUERY,
      [HTTP_HEADER_KEYS.X_ACCESS_TOKEN]
    );
    return response?.tvShowRelatedContent || {};
  } catch (error) {
    console.error('Error while fetching TV Shows related contents: ', error);
    return {};
  }
};
